export default __webpack_public_path__ + "static/tokyo-60cc78c0e1a1ce9dfec3d346b3eb8222.png";